import {
  PAY_ALL_DRIVER_FACTORS,
  PAY_DEBT_TO_DRIVER,
  PAY_DRIVER_DEBT_BY_CHECK_MARK,
  PAY_OFFLINE,
} from "../../routes";
import customAxios from "../../customAxios";
import {
  IPayAllDriverFactors,
  IPayDriverFactors,
} from "../../../types/common.interface";

async function payAllDriverFactors(props: IPayAllDriverFactors) {
  const thisUrl = PAY_ALL_DRIVER_FACTORS + "/" + props.driverId;

  let body: IPayDriverFactors = {
    fishId: props.fishId,
    offlinePayType: props.offlinePayType,
    startAt: props.startAt,
    endAt: props.endAt,
    discount: props.discount,
  };
  // ** ---------------------------------------------------------------------------------------------------------------------
  // ** =====================================================================================================================
  // **                                                      Local Functions
  // ** =====================================================================================================================
  // ** ---------------------------------------------------------------------------------------------------------------------

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ PAY_DEBT_TO_DRIVER: error });
  }
}

export default payAllDriverFactors;
